export const UNAUTHORIZED_ACCESS =
  'You do not have the permission to access the dashboard';
